const USER_TYPES = {
    HUMAN:'human',
    BOT:'bot',
};

export default USER_TYPES;